<template>
    <section class="section-hero">
        <picture class="bg mask" v-if="getHeroImgWebp||getHeroImage">
            <img fetchPriority="auto" :src="getHeroImgWebp||getHeroImage" :alt="alt" />
        </picture>
        <div class="info">
            <h1 v-if="getLangBasedTitle" class="f0">{{ getLangBasedTitle }}</h1>
            <h1 v-else class="f0" v-html="getTitle"></h1>
            <mvtAutocomplete class="sitemap-autocomplete" v-if="sitemap.isAgent" :otherPages="'ST'" v-model="searchInfo"
            ref="autocomplete1" inputRefName="input1" id="textboxGeo1" :classname="'small'" placeholder="Search Agents by City, ZIP" :options="getAutoCompleteOpt"/>
            <sitemapBreadcrumb :breadCrumb="getBreadcrumbData" :isBanner="true" v-if="!sitemap.isAgent"/>
        </div>
    </section>

</template>

<script src="./sitemap-welcome.js"></script>
